import { assertUnreachable, formatBudget } from "@js/utils";

export const getFieldDescription = (
  paymentType: EnumType<typeof ENUMS.JobPaymentType>,
  budgetMin: string,
  budgetMax: string,
) => {
  const budget = formatBudget(budgetMin, budgetMax, {
    paymentType,
    removeDecimal: true,
    hourlyRateSuffix: "/hr",
  });

  return `The client has input a budget of ${budget}`;
};

export const getTitle = (
  paymentType: EnumType<typeof ENUMS.JobPaymentType>,
  jobType: EnumType<typeof ENUMS.JobType>,
) => {
  if (jobType === ENUMS.JobType.DIRECT_HIRE)
    return `Are you okay with the posted pay rate?`;

  switch (paymentType) {
    case ENUMS.JobPaymentType.HOURLY: {
      return `What is your hourly rate for this job?`;
    }
    case ENUMS.JobPaymentType.MONTHLY:
    case ENUMS.JobPaymentType.FIXED_PRICE:
    case ENUMS.JobPaymentType.FIXED_PROJECT:
    case ENUMS.JobPaymentType.PER_TASK:
    case ENUMS.JobPaymentType.ANNUAL: {
      return `Are you okay with the posted pay rate?`;
    }
    default: {
      assertUnreachable(paymentType);
      return "";
    }
  }
};
